// interface

export interface VipData {
    currentLevel: number,
    remainRewards: number,
    VIPRewardsInfo: {
        betTotal: number,
        dailyTotalBet: number,
        weeklyTotalBet: number,
        monthlyTotalBet: number
    },
    nextLevelRecord: {
        bet_min: number,
        daily_reward_retention: number,
        week_reward_retention: number,
        month_reward_retention: number
    },
    nextLevel: number,
    active: number,
    tabelData: Array<VipTableData>,
    vipConfigData: Record<string, any>,
    activity_intro: Array<string>,
    bannerIcon: string

}
export interface TabList {
    id: number,
    name: string
}
export interface VipTableData {
    level: string | number,
    bet_min: string | number,
    upgrade_bonus: number | string,
    daily_reward: string | number,
    weekly_reward: string | number,
    monthly_reward: string | number,
    daily_reward_retention: string | number,
    weekly_reward_retention: string | number,
    monthly_reward_retention: string | number,
}

// Constant

export const TAB_LIST = [
    { id: 1, name: 'vip.VIPIncome' },
    { id: 2, name: 'vip.VIPConditions' },
]
export const TAB_LIST_THREE = [ 
  { id: 1, name: 'vip.bonus' },
  { id: 2, name: 'vip.dailyBonus' },
  { id: 3, name: 'vip.weeklyBonus' },
  { id: 4, name: 'vip.monthlyBonus' },
  { id: 5, name: 'vip.instructions' },
]
 
//function
import { Ref } from 'vue'

export const getVIPHistoryDataFunc = async (
  getVIPRewardHistory: (params: any) => Promise<any>,
  loadingRef: Ref<any>,
  pageNum: Ref<number>,
  pageSize: Ref<number>,
  total: Ref<number>,
  historyList: Ref<any[]>,
  showError: (message: string) => void
) => {
  loadingRef.value.open()
  try {
    const params = {
      pageNum: pageNum.value,
      pageSize: pageSize.value,
    }
    const res = await getVIPRewardHistory(params)
    total.value = res.data.total
    historyList.value = [...historyList.value, ...res.data.rows]
  } catch (err: any) {
    showError(err)
  } finally {
    loadingRef.value.close()
  }
}

